import { render } from "./free-uspto-trademark-search.vue?vue&type=template&id=731e52fd&scoped=true"
import script from "./free-uspto-trademark-search.vue?vue&type=script&lang=js"
export * from "./free-uspto-trademark-search.vue?vue&type=script&lang=js"

import "./free-uspto-trademark-search.vue?vue&type=style&index=0&id=731e52fd&scoped=true&lang=css"
import "./free-uspto-trademark-search.vue?vue&type=style&index=1&id=731e52fd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-731e52fd"]])

export default __exports__